import { PermissionScopeCatalogueEntryModel } from 'models';
import request, { Methods } from 'utils/request';
import { EntityService } from 'utils/entityService';

class PermissionScopeService extends EntityService {
  constructor() {
    super('permission-scopes');
  }

  async getScopeCatalogue() {
    return request<PermissionScopeCatalogueEntryModel[]>({
      method: Methods.GET,
      resource: this.resource,
    });
  }
}

export const permissionScopeService = new PermissionScopeService();
